/**
 * Utility functions for inline CSS handling
 * Note: Global styles are now directly embedded in storyMeta_customstyling by the backend
 */

/**
 * Validates a style activation item
 *
 * @param {object} item - Style activation item
 * @returns {boolean} - Whether the item is valid
 */
export const validateStyleItem = (item) => {
  if (item.type !== 'style') return false;

  if (!item.css) {
    console.error('Invalid style item: missing css property', item);
    return false;
  }

  return true;
};

/**
 * Generates a deterministic style ID based on CSS content hash
 * This ensures the same CSS always gets the same ID, preventing duplicates
 *
 * @param {string} cssContent - The CSS content to hash
 * @returns {string} - Deterministic style ID
 */
export const generateStyleId = (cssContent) => {
  // Simple hash function for CSS content
  let hash = 0;
  for (let i = 0; i < cssContent.length; i++) {
    const char = cssContent.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return `style-${Math.abs(hash).toString(36)}`;
};
